export class EmotionAI {
    constructor(_params) {
        //
    }
    init() {
        //
    }
    async reportPageView() {
        //
    }
    onEAICollectStatusChange() {
        //
    }
    async startCollectingEAIData() {
        //
    }
    async reportVisitorEvent() {
        //
    }
    cleanup() {
        //
    }
    removeListeners() {
        //
    }
    async fetchEAIScore() {
        return undefined;
    }
    async collectEAIEventsAsync() {
        //
    }
}
